<template>
  <q-card flat style="width: 500px; max-width: 100vw;">
    <q-card-section horizontal class="q-ma-sm">
      بررسی هدف
      <q-space/>
      <q-btn icon="close" flat round dense v-close-popup/>
    </q-card-section>
    <q-card-section class="q-pa-xs">
      <q-banner rounded class="bg-blue text-white">
        <template v-slot:avatar>
          <q-icon name="track_changes"/>
        </template>
        {{ auditInfo.description }}
      </q-banner>
    </q-card-section>
    <q-card-section class="q-pa-xs">
      <q-expansion-item
          dense
          ref="newTarget"
          class="shadow-1 overflow-hidden"
          icon="track_changes"
          label="مرور هدف"
          header-class="bg-indigo text-white"
          expand-icon-class="text-white"
          style="border-radius: 10px"
          v-if="$store.state.roles.some(v=>['admin','salemanager','user'].includes(v))"
      >
        <div class="q-ma-xs">
          <div class="row">
            <div class="col-xs-12">
              شما هدفی در باز زمانی
              <q-chip outline color="deep-orange" icon-right="calendar_today" :label="auditInfo.startDate"/>
              تا
              <q-chip outline color="deep-orange" icon-right="calendar_today" :label="auditInfo.endDate"/>
              به شرح <b> {{ auditInfo.description }} </b> و بر اساس شرایط زیر تعریف کرده
              اید:
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="text-subtitle2 text-bold">
                محدوده جغرافیایی:
              </div>
              <div>
                <q-chip v-for="item in auditInfo.states.map(item => item.State_Name)" :key="item.State_ID"
                        square
                        icon="business"
                        :label="item"/>
              </div>
              <div>
                <q-chip v-for="item in auditInfo.cities.map(item => item.City_Name) " :key="item.City_ID" square
                        icon="location_city"
                        :label="item"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="text-subtitle2 text-bold">
                با گروه کالا/کالاهای:
              </div>
              <div>
                <q-chip v-for="item in auditInfo.goodsGroup.map(item => item.Group_Name)" :key="item.Group_ID"
                        square
                        icon="group_work"
                        :label="item"/>
              </div>
              <div>
                <q-chip v-for="item in auditInfo.goods.map(item => item.Goods_Name)" :key="item.Group_ID" square
                        icon="inventory_2"
                        :label="item"/>
              </div>
              <div v-if="this.auditInfo.saleCount">
                <q-chip text-color="white" square color="deep-orange">
                  به تعداد
                  <q-badge align="top" :label="auditInfo.saleCount"/>
                  عدد
                </q-chip>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="text-subtitle2 text-bold">
                کارشناسان / بازاریاب ها:
              </div>
              <div v-if="employees!==null">
                <q-chip
                    v-for="item in JSON.parse(auditInfo.employees)" :key="item.Users_ID"
                    square
                    icon="person"
                    :label="item.UserName"/>
              </div>
            </div>
          </div>

        </div>
      </q-expansion-item>
    </q-card-section>
    <q-card-section>
      <div>
        مبلغ فروخته شده
        <q-badge color="red" text-color="white" align="top"
                 :label="`${Math.abs(auditInfo.salePriceProgress).toLocaleString()}/${Math.abs(auditInfo.salePrice==='None'?'0':auditInfo.salePrice).toLocaleString()}`"/>
      </div>
      <q-linear-progress class="q-mb-xs" size="25px"
                         :value="(Math.abs(auditInfo.salePriceProgress / auditInfo.salePrice===0?1: auditInfo.salePrice))" color="red">
        <div class="absolute-full flex flex-center">
          <q-badge color="white" text-color="accent"
                   :label="`${ (Math.abs(auditInfo.salePriceProgress / auditInfo.salePrice===0?1: auditInfo.salePrice ) * 100).toFixed(2)}%`"/>
        </div>
      </q-linear-progress>
      <q-expansion-item
          dense
          ref="newTarget"
          class="shadow-1 overflow-hidden"
          icon="person"
          label="به تفکیک نفر"
          header-class="bg-indigo text-white"
          expand-icon-class="text-white"
          style="border-radius: 10px"
          v-if="auditInfo.salePriceProgress!==0 && $store.state.roles.some(v=>['admin','salemanager','user'].includes(v))"
      >
        <q-chip square class="q-ma-xs"
                v-for="(item, index) in lodash.orderBy(salePriceByUser.filter(item=>parseInt(item.TotalSum)>0),['TotalSum'],['desc'])"
                :key="index" color="indigo"
                text-color="white"
                :label="item.UserName">
          <q-badge color="red-10" text-color="white" :label="item.TotalSum.toLocaleString()" class="q-mr-xs"/>
          <q-badge color="red-14" text-color="white"
                   :label="`${((Math.abs(item.TotalSum / auditInfo.salePrice ) * 100).toFixed(2))}%`"/>
        </q-chip>
      </q-expansion-item>
    </q-card-section>
    <q-card-section class="">
      <div>
        تعداد کالای فروخته شده
        <q-badge color="red" text-color="white" align="top"
                 :label="`${Math.abs(auditResult.RealSaleCount)}/${Math.abs(auditInfo.saleCount)}`"/>
      </div>
      <q-linear-progress class="q-mb-xs" size="25px" :value="Math.abs(auditResult.realSaleCountProgress / 100)"
                         color="red">
        <div class="absolute-full flex flex-center">
          <q-badge color="white" text-color="accent"
                   :label="`${Math.abs(auditResult.realSaleCountProgress)}%`"/>
        </div>
      </q-linear-progress>
      <q-expansion-item
          dense
          ref="newTarget"
          class="shadow-1 overflow-hidden"
          icon="person"
          label="به تفکیک نفر"
          header-class="bg-indigo text-white"
          expand-icon-class="text-white"
          style="border-radius: 10px"
          v-if="auditResult.RealSaleCount!==0 && $store.state.roles.some(v=>['admin','salemanager','user'].includes(v))"
      >
        <q-chip square class="q-ma-xs"
                v-for="(item, index) in lodash.orderBy(saleOrd.filter(item=>parseInt(item.RealSaleCount)>0),['RealSaleCount'],['desc'])"
                :key="index" color="indigo" text-color="white"
                :label="item.UserName">
          <q-badge color="red-10" text-color="white" :label="item.RealSaleCount" class="q-mr-xs"/>
          <q-badge v-if="auditInfo.saleCount!==0" color="red-14" text-color="white"
                   :label="`${((item.RealSaleCount / auditInfo.saleCount)*100).toFixed(2)}%`"/>
        </q-chip>
      </q-expansion-item>
    </q-card-section>
    <q-card-section>
      <div>
        بازدید از طرف معامله در محل
        <q-badge color="green" text-color="white" align="top"
                 :label="`${this.auditResult.RealVisit_Count}/${auditInfo.visitCustomer}`"/>
      </div>
      <q-linear-progress class="q-mb-xs" size="25px" :value="auditResult.realVisitCountProgress / 100" color="green">
        <div class="absolute-full flex flex-center">
          <q-badge color="white" text-color="accent"
                   :label="`${auditResult.realVisitCountProgress}%`"/>
        </div>
      </q-linear-progress>
      <q-expansion-item
          dense
          ref="newTarget"
          class="shadow-1 overflow-hidden"
          icon="person"
          label="به تفکیک نفر"
          header-class="bg-indigo text-white"
          expand-icon-class="text-white"
          style="border-radius: 10px"
          v-if="auditInfo.visitCustomer!==0 && $store.state.roles.some(v=>['admin','salemanager','user'].includes(v))"
      >
        <q-chip square class="q-ma-xs" v-for="(item, index) in visitLog" :key="index" color="indigo" text-color="white"
                :label="item.UserName">
          <q-badge color="red-10" text-color="white" :label="item.RealVisit_Count" class="q-mr-xs"/>
          <q-badge v-if="auditInfo.visitCustomer!==0"
                   color="red-14" text-color="white"
                   :label="`${((item.RealVisit_Count / auditInfo.visitCustomer)*100).toFixed(2)}%`"/>
        </q-chip>
      </q-expansion-item>
    </q-card-section>
    <q-card-section>
      <div>
        طرف معامله جدید
        <q-badge color="brown" text-color="white" align="top"
                 :label="`${auditResult.RealCustomerCount}/${auditInfo.newCustomer}`"/>
      </div>
      <q-linear-progress class="q-mb-xs" size="25px" :value="auditResult.realCustomerCountProgress / 100 "
                         color="brown">
        <div class="absolute-full flex flex-center">
          <q-badge color="white" text-color="accent"
                   :label="`${auditResult.realCustomerCountProgress}%`"/>
        </div>
      </q-linear-progress>
      <q-expansion-item
          dense
          ref="newTarget"
          class="shadow-1 overflow-hidden"
          icon="person"
          label="به تفکیک نفر"
          header-class="bg-indigo text-white"
          expand-icon-class="text-white"
          style="border-radius: 10px"
          v-if="$store.state.roles.some(v=>['admin','salemanager','user'].includes(v)) && auditInfo.newCustomer!==0">
        <q-chip square class="q-ma-xs" v-for="(item, index) in customerLog" :key="index" color="indigo"
                text-color="white"
                :label="item.UserName">
          <q-badge color="red-10" text-color="white" :label="item.RealCustomerCount" class="q-mr-xs"/>
          <q-badge v-if="auditInfo.newCustomer!==0" color="red-14" text-color="white"
                   :label="`${((item.RealCustomerCount / auditInfo.newCustomer)*100).toFixed(2)}%`"/>
        </q-chip>
      </q-expansion-item>
    </q-card-section>

    <q-card-section>
      <div>
        تماس های برقرار شده
        <q-badge color="brown" text-color="white" align="top"
                 :label="`${auditResult.telCount}/${auditInfo.callCustomer}`"/>
      </div>
      <q-linear-progress size="25px" :value="auditInfo.callCustomer===0?0:auditResult.telCount / auditInfo.callCustomer"
                         color="brown">
        <div class="absolute-full flex flex-center">
          <q-badge color="white" text-color="accent"
                   :label="`${auditInfo.callCustomer===0?'0': (auditResult.telCount / auditInfo.callCustomer).toFixed(2)}%`"/>
        </div>
      </q-linear-progress>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  name: "AuditTarget",
  props: ['auditInfo', 'auditResult', 'saleOrd', 'visitLog', 'customerLog', 'employees', 'salePriceByUser'],
  created() {
  }
}
</script>

<style scoped>

</style>
